import Service, { service } from '@ember/service';
import type { Query, User } from 'graphql-models';
import meQuery from 'walden-trace-app/graphql/user/me.graphql';
import type ApiService from './api';
import type SessionService from './session';

export default class UserService extends Service {
  @service('api') declare apiService: ApiService;
  @service('session') declare sessionService: SessionService;

  async getUser(): Promise<User | null> {
    if (this.sessionService.isGuest) {
      return null;
    }

    const { me } = await this.apiService.query<{ me: Query['me'] }>({
      query: meQuery,
    });

    if (!me) {
      throw new Error('User not found');
    }

    return me;
  }

  logout() {
    void this.sessionService.unauthenticate();
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:user')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('user') declare altName: UserService;`.
declare module '@ember/service' {
  interface Registry {
    user: UserService;
  }
}
